import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationSummaryStudentsDetail(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/inadimplencia/get_student_inadimplance/', {params});
  return data;
}

type QueryFnType = typeof getConsolidationSummaryStudentsDetail;

function useConsolidationSummaryStudentsDetail(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-summary-students-detail', params],
    queryFn: () => getConsolidationSummaryStudentsDetail(params),
  });
}

export { getConsolidationSummaryStudentsDetail, useConsolidationSummaryStudentsDetail };
